import { motion, useScroll, useTransform } from 'motion/react'
import { type DetailedHTMLProps, type ImgHTMLAttributes, useRef } from 'react'
import { cn } from '#app/utils/misc.js'

export default function MarketingImage({
	imageClassName,
	disableHover = false,
	...props
}: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
	imageClassName?: string
	disableHover?: boolean
}) {
	const ref = useRef(null)
	const { scrollYProgress } = useScroll({
		target: ref,
		offset: ['start end', 'end start'],
	})
	const translateY = useTransform(
		scrollYProgress,
		// Map x from these values:
		[0, 1],
		// Into these values:
		['5%', '-5%'],
	)

	return (
		<motion.div
			ref={ref}
			initial={{ opacity: 0, scale: 0.95, y: -5 }}
			whileInView={{
				transition: {
					delay: 0.25,
					duration: 0.225,

					ease: 'easeInOut',
				},
				y: 0,
				scale: 1,
				opacity: 1,
			}}
			className={cn('group relative overflow-hidden', props.className)}
			style={{ translateY: translateY, ...props.style }}
		>
			{!disableHover && (
				<div className="absolute inset-0 h-full w-full bg-brand-aquamarine opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-80" />
			)}
			{/* @ts-expect-error */}
			<motion.img
				{...props}
				className={cn(
					'h-full w-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105',
					imageClassName,
				)}
			/>
		</motion.div>
	)
}
